export const RULE_IN_EDITION_LABEL = "Regra atual em edição";
export const RULE_PIECE_IN_EDITION_LABEL = "Trecho de regra em edição";
export const COMPANY_EVENT_CONTEXT_LABEL = "Contexto do evento da empresa";
export const REFERENCED_RULE_PIECE_LABEL = "Trecho de regra referenciado: ";

export function buildRuleEntry(ruleData) {
    return {
        text: ruleData.is_rule_piece ? RULE_PIECE_IN_EDITION_LABEL : RULE_IN_EDITION_LABEL,
        data: ruleData
    };
}

export function buildCompanyEventEntry(payload) {
    return { text: COMPANY_EVENT_CONTEXT_LABEL, data: payload };
}

export function buildRulePieceEntry(definition) {
    return {
        text: REFERENCED_RULE_PIECE_LABEL + definition.rule_piece_key,
        data: definition
    };
}
